<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';
import { computed } from 'vue';

import { omit } from '@nora-monorepo/shared';

export interface GrammarRadioButtonItemProps {
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'top';
  label?: string;
  value?: string;
  position?: 'left' | 'middle' | 'right';
  readOnly?: boolean;
  selected?: boolean;
  size?: 'regular' | 'small';
  style?: string;

  // Custom
  iconColor?: string;
}

const props = withDefaults(defineProps<GrammarRadioButtonItemProps>(), {
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  label: '',
  value: '',
  position: 'middle',
  readOnly: false,
  selected: false,
  size: 'regular',
  style: '',

  // Custom
  iconColor: '',
});

const webComponentProps = computed(() => {
  const supportedProps = omit(props, ['iconColor']);
  if (!props.iconColor) {
    return supportedProps;
  }

  return Object.assign(supportedProps, {
    style: [
      props.style,
      `
--formsRadioButtonItemColorForegroundUnselectedEnabled: ${props.iconColor};
--formsRadioButtonItemColorForegroundUnselectedHover: ${props.iconColor};
--formsRadioButtonItemColorForegroundSelectedEnabled: ${props.iconColor};
--formsRadioButtonItemColorForegroundSelectedHover: ${props.iconColor};
--formsRadioButtonItemColorForegroundUnselectedPressed: ${props.iconColor};
      `,
    ].filter(Boolean).join('\n'),
  });
});
</script>

<template>
  <tpg-radio-button-item
    v-bind="webComponentProps"
  />
</template>
